import { businessId, isClosedConversationStore } from "../store";
import { dataObj } from "./getdata";
import { dataAttributes } from './getdata'
import { sendBookingDataToGA } from './sendBookingToGA'
import { getClickIds } from "./utilities";

function tagging(person, extraData) {
    let event = 'chatwith';

    isClosedConversationStore.subscribe(value => {
        if (value) {
            event = 'CW_LeadClose';
        };
    });

    let extras = {}

    extras = {
        'widget': person.businessGaTag ? person.businessGaTag : 'whatapp',
        'agent': person.gaTag ? person.gaTag : person.id
    }

    if (typeof window.fbq === 'function') {
        //console.log("fb")
        window.fbq('trackCustom', 'chatWithEvent', extras);
    }

    if (typeof window.gtag === "function") {
        console.log("old gtag")
    }


    let widgetKey;
    businessId.subscribe(value => {
        widgetKey = value;
    });

    const { FbClid, GClid, TTClid, WBraid, GBraid } = getClickIds(widgetKey);

    if (typeof window.dataLayer === "object") {
        const payload = {
            event,
            cw_event_category: person.businessGaTag ? person.businessGaTag : "whatsapp",
            cw_event_action: "chatwith",
            cw_event_label: person.gaTag ? person.gaTag : person.id,
            cw_event_name: extraData?.firstname || "",
            cw_event_email: extraData?.email || "",
            cw_event_phone: extraData?.tel || "",
        };

        if (FbClid) payload.cw_event_fbclid = FbClid;
        if (GClid) payload.cw_event_gclid = GClid;
        if (TTClid) payload.cw_event_ttclid = TTClid;
        if (WBraid) payload.cw_event_wbraid = WBraid;
        if (GBraid) payload.cw_event_gbraid = GBraid;

        window.dataLayer.push(payload);
    }


    sendBookingDataToGA()
}

export { tagging };
